export default "__VITE_PUBLIC_ASSET__55d1e569__"